const initialState = {
    get: [],
    region:[],
    country:[],
    
  };
  
  const AOfficerReducers = (state = initialState, action: any) => {
    switch (action.type) {
      case 'fetch_GET_success':
        return { ...state, get: action.payload };
        case 'fetch_Region_success':
            return { ...state, region: action.payload };
            case 'fetch_Country_success':
                return { ...state, country: action.payload };
        
      
    

      default:
        return state;
    }
  };
  
  export default AOfficerReducers;
  
  